import { PropsWithChildren, useCallback } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { FilterQueryContextProvider } from 'src/contexts/FilterQueryContext';
import { ReportMetricsContextProviderV2 } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';
import { ReportConfigV2 } from 'src/hooks/reportConfigs';
import { EmptyReportV2PurchaseOrderLineItemQuery } from 'src/utils/eventQueryUtils';
import {
  ReportV2Client,
  UIReportV2PurchaseOrderLineItemQuery,
} from 'src/WebApiController';

export function ReportsPurchaseOrderLineItemContextProviderV2({
  reportConfig,
  isExport,
  children,
}: PropsWithChildren<{
  reportConfig: ReportConfigV2;
  isExport?: boolean;
}>) {
  const { activeAccountWebClientConfig } = useAppContext();

  const getReportMetrics = useCallback(
    (
      tempReportConfig: ReportConfigV2,
      filters: UIReportV2PurchaseOrderLineItemQuery,
      pageNumber: number
    ) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getPurchaseOrderLineItemReportMetrics({
        ...tempReportConfig.request,
        pageNumber,
        filters,
      });
    },
    [activeAccountWebClientConfig]
  );

  const getReportMetricsSummary = useCallback(
    (
      tempReportConfig: ReportConfigV2,
      filters: UIReportV2PurchaseOrderLineItemQuery
    ) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getPurchaseOrderLineItemReportSummary({
        ...tempReportConfig.request,
        filters,
      });
    },
    [activeAccountWebClientConfig]
  );

  return (
    <FilterQueryContextProvider<UIReportV2PurchaseOrderLineItemQuery>
      initialQuery={
        reportConfig.request.filters as UIReportV2PurchaseOrderLineItemQuery
      }
      emptyQuery={EmptyReportV2PurchaseOrderLineItemQuery}
      loadQueryFromUrl={false}
    >
      <ReportMetricsContextProviderV2<UIReportV2PurchaseOrderLineItemQuery>
        queryKey="getReportPurchaseOrderLineItemItemMetricsV2"
        getReportMetrics={getReportMetrics}
        getReportMetricsSummary={getReportMetricsSummary}
        disabled={isExport}
        reportConfig={reportConfig}
      >
        {children}
      </ReportMetricsContextProviderV2>
    </FilterQueryContextProvider>
  );
}
